import { defineComponent } from 'vue'

import { Container, ContainerStatus } from '@skinsoft/types'
import { ContainerDataStore } from '@skinsoft/entity'
import { containerSelectors } from '@skinsoft/entity-ui'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { AddContainerModal, StateInput } from '@skinsoft/ui'

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sStateInput: StateInput,
        sContainerModal: AddContainerModal,
    },
    props: {
        statusesToSearch: {
            type: Array,
            required: false,
        },
        excludedIds: Array,
    },
    template: require('./container-input.html'),
    data() {
        return {
            selectedContainer: null as unknown as Container,
            containerDatastore: null as unknown as ContainerDataStore,
        }
    },
    created() {
        this.containerDatastore = ContainerDataStore.getInstance()
    },
    methods: {
        openPopup() {
            (this.$refs.containerModal as InstanceType<typeof AddContainerModal>).open()
        },
        onContainerSelected(container: {id: string, type: string}) {
            this.containerDatastore.fetchOne(container.id).subscribe(container => {
                this.selectedContainer = container
                ;(this.$refs.stateInput as InstanceType<typeof StateInput>).setValue(containerSelectors.identifier(this.selectedContainer) || containerSelectors.title(this.selectedContainer))
            })

            this.$emit('change', container)
        },
    },
})
